import { useRef, useEffect } from 'react';

/**
 * Useful hook if you need to keep a previous value
 * for a prop or a state
 *
 * @param value - value to keep a previous version of
 */
export function usePrevious<T>(value: T): T {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
